import { SummaryRow } from '../../../Summary/SummaryRow';
import { IRisk } from '../../../../types';
import { isFundingRisk } from '../../../../utilities/risks';
import { useTranslation } from "react-i18next";

interface Props {
  id: string;
  showRisks: boolean;
  risk: IRisk['financeDocsRisk']['birthCertificate'];
  isLegalDocument: boolean;
  hasAllNames: boolean;
  inEnglish: boolean;
  hasTranslation: boolean;
  uploadedBy?: string;
}

export default function BirthCertificate({
  id,
  showRisks,
  risk,
  isLegalDocument,
  hasAllNames,
  inEnglish,
  hasTranslation,
  uploadedBy,
}: Props) {
    const { t } = useTranslation('forms.finance');
  if (isLegalDocument === undefined && hasAllNames === undefined) {
    return <div>{t('forms.finance:uploadedBy')} {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="isLegalDocument"
        label={t('forms.finance:isLegalDocument')}
        fullLabel="Are you uploading a scan of the original legal document?"
        value={isLegalDocument ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'isLegalDocument', id)}
      />

      <SummaryRow
        key="hasAllNames"
        label={t('forms.finance:hasAllNames')}
        fullLabel="Does the document include your name and the name of the parent/guardian providing funds?"
        value={hasAllNames ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'hasAllNames', id)}
      />

      <SummaryRow
        key="inEnglish"
        label={t('forms.finance:english')}
        fullLabel="Is the letter in English?"
        value={inEnglish ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
      />

      {!inEnglish && (
        <SummaryRow
          key="hasTranslation"
          label={t('forms.finance:hasTranslation')}
          fullLabel="Have you provided an English translation of the letter?"
          value={hasTranslation ? 'Yes' : 'No'}
          isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
        />
      )}
    </>
  );
}
